var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-edit-retention-policy',{attrs:{"isEdit":false,"cancelRoute":"Retention policies"}})
}
var staticRenderFns = []

export { render, staticRenderFns }